/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {FormattedDate, FormattedMessage, FormattedTime, useIntl} from 'react-intl'
import {useMutation, useQuery} from 'react-query'
import {statusColor} from '../../../../../../../../_metronic/helpers/custom/funcs/statusColor'
import {usePageData} from '../../../../../../../../_metronic/layout/core'
import {Portal} from '../../../../../../../../_metronic/partials'
import {useAuth} from '../../../../../../../modules/auth'
import {ActionConfirmation} from '../../../../../../../modules/custom/modals/ActionConfirmation'
import {useQueryResponse} from '../../../../core/QueryResponseProvider'
import {Buyout} from '../../../../core/_models/_buyout-models'
import {confirmBuyout, getBuyoutStatuses} from '../../../../core/_requests'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'

type Props = {
  buyout: Buyout
}

const BuyoutStatusCell = ({buyout}: Props) => {
  const {status, summary, user_confirm, no_money, id} = buyout
  const {refetch} = useQueryResponse()
  // const [show, setShow] = useState(false)

  const {currentUser} = useAuth()
  const [confirmModalOpen, setConfirmModalOpen] = useState(false)

  const intl = useIntl()
  const confirmMutation = useMutation<any, Error>(
    async () => {
      return await confirmBuyout(id)
    },
    {
      onSuccess: () => {
        // setShow(true)
        refetch()
      },
      onSettled: () => {
        setConfirmModalOpen(false)
      },
      onError: (error) => {
        console.log(error)
      },
    }
  )
  const {data: buyoutStatuses} = useQuery(
    ['buyoutStatuses', intl.locale, buyout.id],
    () => {
      return getBuyoutStatuses(buyout.id)
    },
    {keepPreviousData: true, retry: false}
  )
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [buyout.id, buyoutStatuses])

  const {setPageCustomData, addNotification} = usePageData()
  const moneyForPaymentConfirmation = no_money === true && currentUser?.vip === 0 ? false : true
  return (
    <div className='text-center'>
      {confirmModalOpen && (
        <Portal
          children={
            <ActionConfirmation
              actionName={intl.formatMessage({id: 'BUYOUT_PAGE.CONF_BUYOUT_CONF'})}
              setModalOpen={setConfirmModalOpen}
              handleAction={() => confirmMutation.mutate()}
              id={id}
              isOpen={confirmModalOpen}
            />
          }
          className='modal-root'
        />
      )}
      {buyoutStatuses && (
        <div className='d-flex flex-column align-items-center'>
          <div className='d-flex align-items-center gap-2'>
            <div className='d-flex flex-column'>
              <span className='text-dark fw-bold fs-6'>{buyoutStatuses.statusLogs[0]?.name}</span>
              {buyoutStatuses.statusLogs[0]?.createdAt && (
                <span className='text-dark fw-bold fs-7'>
                  <FormattedDate
                    year='numeric'
                    month='numeric'
                    day='numeric'
                    value={buyoutStatuses.statusLogs[0]?.createdAt}
                  />
                </span>
              )}
            </div>
            {buyoutStatuses.statusLogs && buyoutStatuses.statusLogs.length > 1 && (
              <>
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                >
                  <i className='fas fa-ellipsis-v'></i>
                </button>
                <div
                  className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-3 mw-300px mw-lg-400px w-100'
                  data-kt-menu='true'
                >
                  <div className='menu-item px-3'>
                    <div className='table-responsive'>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 mb-0 text-center'>
                        <tbody>
                          {buyoutStatuses.statusLogs.map((log: any, index: number) => (
                            <tr key={index}>
                              <td>
                                <span className='text-dark fw-bold fs-6'>{log.name}</span>
                              </td>
                              <td>
                                <span className='text-dark fw-bold fs-7'>
                                  <FormattedDate
                                    year='numeric'
                                    month='numeric'
                                    day='numeric'
                                    value={log.createdAt}
                                  />{' '}
                                  <FormattedTime value={log.createdAt} />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {!buyoutStatuses && (
        <p className='text-dark fw-bold text-hover-primary d-block fs-6 p-0 m-0'>{status}</p>
      )}{' '}
      {
        // isArchive === false &&
        summary > 0 && user_confirm === 0 && (
          <div className='mt-2'>
            {' '}
            <span
              className={`p-1 cursor-pointer fw-semobold  StatusBar__status ${statusColor(
                moneyForPaymentConfirmation
              )}`}
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_checkout'
              onClick={() => {
                if (moneyForPaymentConfirmation === false) {
                  // if (currentUser?.can_add_balance === 0) {
                  //   addNotification({
                  //     status: 'danger',
                  //     body: 'GENERAL.TOOLTIPS.PROH_PAYMENT',
                  //   })
                  // } else {
                  setPageCustomData({
                    debts: 0,
                    checkoutShow: true,
                    checkoutSum:
                      currentUser?.balance && currentUser?.balance > 0
                        ? (summary - currentUser.balance).toFixed(2)
                        : summary,
                    confirmRequest: confirmMutation.mutate,
                    confirmId: id,
                    showPayAll: true,
                  })
                  // }
                } else {
                  setConfirmModalOpen(true)
                }
              }}
            >
              <FormattedMessage
                id='GENERAL.BUTTONS.CONFIRM_PAYMENT'
                values={{sum: currentUser?.vip === 0 ? `$${summary}` : ''}}
              />
            </span>
          </div>
        )
      }
    </div>
  )
}

export {BuyoutStatusCell}
